/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import VxFloatingInput from './components/VxFloatingInput.vue'
import VsRow from './components/vuesax/VsRow.vue'
import VsCol from './components/vuesax/VsCol.vue'
import VsInput from './components/vuesax/VsInput.vue'
import VsTextarea from './components/vuesax/VsTextarea.vue'
import VsButton from './components/vuesax/VsButton.vue'
import VsCheckbox from './components/vuesax/VsCheckbox.vue'
import VsRadio from './components/vuesax/VsRadio.vue'
import VsSwitch from './components/vuesax/VsSwitch.vue'
import VsSelect from './components/vuesax/VsSelect.vue'
import VsSelectItem from './components/vuesax/VsSelectItem.vue'
import VsSelectGroup from './components/vuesax/VsSelectGroup.vue'
import VsList from './components/vuesax/VsList.vue'
import VsListItem from './components/vuesax/VsListItem.vue'
import VsListHeader from './components/vuesax/VsListHeader.vue'
import VsChip from './components/vuesax/VsChip.vue'
import VsDivider from './components/vuesax/VsDivider.vue'
import VsIcon from './components/vuesax/VsIcon.vue'
import VsDropdown from './components/vuesax/VsDropdown.vue'
import VsDropdownMenu from './components/vuesax/VsDropdownMenu.vue'
import VsDropdownItem from './components/vuesax/VsDropdownItem.vue'
import VsDropdownGroup from './components/vuesax/VsDropdownGroup.vue'
import VsCollapse from './components/vuesax/VsCollapse.vue'
import VsCollapseItem from './components/vuesax/VsCollapseItem.vue'
import VsTabs from './components/vuesax/VsTabs.vue'
import VsTab from './components/vuesax/VsTab.vue'
import VsPagination from './components/vuesax/VsPagination.vue'
import VsTable from './components/vuesax/VsTable.vue'
import VsTh from './components/vuesax/VsTh.vue'
import VsTr from './components/vuesax/VsTr.vue'
import VsTd from './components/vuesax/VsTd.vue'
import VsPrompt from './components/vuesax/VsPrompt.vue'
import VsPopup from './components/vuesax/VsPopup.vue'
import VsSidebar from './components/vuesax/VsSidebar.vue'
import VsNavbar from './components/vuesax/VsNavbar.vue'
import VsUpload from './components/vuesax/VsUpload.vue'
import VsAlert from './components/vuesax/VsAlert.vue'
import VsAvatar from './components/vuesax/VsAvatar.vue'
import VsCard from './components/vuesax/VsCard.vue'
import VsInputNumber from './components/vuesax/VsInputNumber.vue'

// v-select component
import vSelect from 'vue-select'

export default function registerGlobalComponents(app) {
  app.component(VxTooltip.name, VxTooltip)
  app.component(VxCard.name, VxCard)
  app.component(VxList.name, VxList)
  app.component(VxBreadcrumb.name, VxBreadcrumb)
  app.component(FeatherIcon.name, FeatherIcon)
  app.component(VxInputGroup.name, VxInputGroup)
  app.component(VxFloatingInput.name, VxFloatingInput)
  app.component(vSelect.name || 'v-select', vSelect)
  app.component(VsRow.name, VsRow)
  app.component(VsCol.name, VsCol)
  app.component(VsInput.name, VsInput)
  app.component(VsTextarea.name, VsTextarea)
  app.component(VsButton.name, VsButton)
  app.component(VsCheckbox.name, VsCheckbox)
  app.component(VsRadio.name, VsRadio)
  app.component(VsSwitch.name, VsSwitch)
  app.component(VsSelect.name, VsSelect)
  app.component(VsSelectItem.name, VsSelectItem)
  app.component(VsSelectGroup.name, VsSelectGroup)
  app.component(VsList.name, VsList)
  app.component(VsListItem.name, VsListItem)
  app.component(VsListHeader.name, VsListHeader)
  app.component(VsChip.name, VsChip)
  app.component(VsDivider.name, VsDivider)
  app.component(VsIcon.name, VsIcon)
  app.component(VsDropdown.name, VsDropdown)
  app.component(VsDropdownMenu.name, VsDropdownMenu)
  app.component(VsDropdownItem.name, VsDropdownItem)
  app.component(VsDropdownGroup.name, VsDropdownGroup)
  app.component(VsCollapse.name, VsCollapse)
  app.component(VsCollapseItem.name, VsCollapseItem)
  app.component(VsTabs.name, VsTabs)
  app.component(VsTab.name, VsTab)
  app.component(VsPagination.name, VsPagination)
  app.component(VsTable.name, VsTable)
  app.component(VsTh.name, VsTh)
  app.component(VsTr.name, VsTr)
  app.component(VsTd.name, VsTd)
  app.component(VsPrompt.name, VsPrompt)
  app.component(VsPopup.name, VsPopup)
  app.component(VsSidebar.name, VsSidebar)
  app.component(VsNavbar.name, VsNavbar)
  app.component(VsUpload.name, VsUpload)
  app.component(VsAlert.name, VsAlert)
  app.component(VsAvatar.name, VsAvatar)
  app.component(VsCard.name, VsCard)
  app.component(VsInputNumber.name, VsInputNumber)
}
